import { useState, useEffect } from 'react';
import { MarketData, LoadingStates } from '../types';

const useMarketData = (): [MarketData[], LoadingStates] => {
  const [marketData, setMarketData] = useState<MarketData[]>([]);
  const [loadingStatus, setLoadingStatus] = useState<LoadingStates>('loading');

  useEffect(() => {
    fetch(`${process.env.REACT_APP_STRAPI_FQDN}/markets`)
      .then((res) => {
        if (!(res.status === 200)) {
          throw new Error('Failed to fetch data from backend');
        }
        return res.json();
      })
      .then((data: MarketData[]) => {
        setMarketData(data);
        setLoadingStatus('completed');
      })
      .catch((error) => {
        setLoadingStatus('error');
        // eslint-disable-next-line no-console
        console.error(error);
      });
  }, []);

  return [marketData, loadingStatus];
};

export default useMarketData;
